// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Contacts_wrapper__yfOue","contact_info":"Contacts_contact_info__bp9bf"};